import type { UseListProps } from '@ztechapps/common.hook'
import { StorageType, useList, useUserTimeZone } from '@ztechapps/common.hook'
import { workOrderListFragment } from './graphql'
import type { SetOptional } from 'type-fest'
import { gql } from '@apollo/client'

export const workOrderListQuery = gql`
  query workOrderList($filter: JSON, $options: JSON) {
    workOrderList(filter: $filter, options: $options) {
      ...workOrderListFragment
    }
    workOrderListMeta(filter: $filter) {
      count
    }
  }
  ${workOrderListFragment}
`

export const useWorkOrderList = ({ listActionOptions = {}, query, ...props }: SetOptional<UseListProps, 'query'>) => {
  const timeZone = useUserTimeZone()

  query = query ?? workOrderListQuery

  const finalDefaultListActions = {
    ...listActionOptions,
    storageType: StorageType.localStorage,
    timeZone,
  }

  return useList({
    query,
    ...props,
    limit: 100,
    sort: { createdAt: -1 },
    listActionOptions: finalDefaultListActions,
  })
}
